$(document).ready(function() {
	if ($('.brand-slider').attr('data-loop') === 'true') {
		let $firstLogoContainer = $('.brand-slider__container .brand-slider__inner').first();
		let $clone = $firstLogoContainer.clone();
		$('.brand-slider__container .brand-slider__cover').append($clone);

		function checkPositionsAndReset() {
			var $logoContLeft = $('.brand-slider__container').offset().left;
			var $secondLogoContainerLeft = $('.brand-slider__cover .brand-slider__inner').last().offset().left;

			if ($secondLogoContainerLeft <= $logoContLeft) {
				$('.brand-slider__cover').css({
					'animation': 'none',
					'transform': 'translateX(0%)'
				});
			}

			void $('.brand-slider__cover').width();

			$('.brand-slider__cover').css('animation', 'scrollLogo 170s linear infinite');

			requestAnimationFrame(checkPositionsAndReset);
		}

		checkPositionsAndReset();
	}
});